module.exports = __webpack_public_path__ + "img/cert8.9a4b85db.png";